import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, map as _map } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { showAlertMessage, Select, RenderTableHeaderValue, RenderTableCellValue, DateRangePicker, } from "../../../../resusableComponents/common/formElements";

import { withRouter } from "../../../../resusableComponents/hoc/withRouter";
import ReactDataTable from "../../../../resusableComponents/common/ReactDataTable";

import { updatePageLevelLoadingState } from "../../../../redux/actions/application";
import { downloadExcelFile } from "../../../../helpers/utils";

import { fetchWebScrapingFilters, getWebScrapingDashboard, getWebScrapingData, exportWebScrapingData, } from "../../../../redux/services/auditDashboard";
import { exportSearchData } from "../../../../redux/services/dataSearch";

class AuditDashboard extends Component {
  constructor(props) {
    super(props);
    const { intl } = props;

    this.defaultPayload = {
      user_ids: null,
      start_date: "",
      end_date: "",
      status_ids: null,
      page_no: 1,
      page_size: 10,
      orderby: null,
      order: null,
    };

    this.state = {
      activeRequestCount: 0,
      filterData: {},
      tilesData: {},
      tableData: {},
      selectedUsers: null,
      selectedStatus: null,
      resetDateRangePicker: false,
      defaultPayload: { ...this.defaultPayload },
      selectedRows: [],
      selectAllRows: false,
    };

    this.tableColumns = [
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.status", defaultMessage: "Status", })} />
        ),
        selector: (row) => _get(row, "status_text", ""),
        cell: (row) => {
          const status = _get(row, "status", null);
          const statusText = _get(row, "status_text", "");
          const errorMessage = _get(row, "error_message", null);
          const badgeClass = _get(row, "color_code", "");

          const badge = (
            <RenderTableCellValue className={badgeClass} value={statusText} />
          );

          if (status === 3 && errorMessage) {
            return (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id={`error-tooltip-${_get(row, "search_id", "")}`} className="custom-tooltip">
                    <div className="criteria-tooltip-content">
                      <div className="criteria-item">
                        <span className="criteria-label">Error:</span>
                        <span className="criteria-value">{errorMessage}</span>
                      </div>
                    </div>
                  </Tooltip>
                }
              >
                <span className="d-inline-flex align-items-center gap-1 cursor-pointer">
                  {badge}
                  <img src={require("../../../../assets/icons/icon-info.svg").default} className="img-fluid" alt="Error info" width="14" />
                </span>
              </OverlayTrigger>
            );
          }

          return badge;
        },
        sortable: true,
        sortField: "status",
        grow: 0.6,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.created_at", defaultMessage: "Created At", })} />
        ),
        selector: (row) => _get(row, "created_at", ""),
        cell: (row) => <RenderTableCellValue value={_get(row, "created_at", "")} />,
        sortable: true,
        sortField: "created_at",
        grow: 0.6,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.search_id", defaultMessage: "Search ID", })} />
        ),
        selector: (row) => _get(row, "search_id", ""),
        cell: (row) => <RenderTableCellValue value={_get(row, "search_id", "")} />,
        sortable: true,
        sortField: "search_id",
        grow: 0.5,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.search_name", defaultMessage: "Search Name", })} />
        ),
        selector: (row) => _get(row, "search_name", ""),
        cell: (row) => <RenderTableCellValue tooltip={true} value={_get(row, "search_name", "")} />,
        sortable: true,
        sortField: "search_name",
        grow: 2,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.lead_count", defaultMessage: "Lead Count", })} />
        ),
        selector: (row) => _get(row, "lead_count", 0),
        cell: (row) => <RenderTableCellValue value={_get(row, "lead_count", 0)} />,
        sortable: true,
        sortField: "lead_count",
        grow: 0.5,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.scrape_count", defaultMessage: "Scrape Count", })} />
        ),
        selector: (row) => _get(row, "scrape_count", 0),
        cell: (row) => <RenderTableCellValue value={_get(row, "scrape_count", 0)} />,
        sortable: true,
        sortField: "scrape_count",
        grow: 0.5,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.user_name", defaultMessage: "User Name", })} />
        ),
        selector: (row) => _get(row, "user_name", ""),
        cell: (row) => <RenderTableCellValue className="text-capitalize" value={_get(row, "user_name", "")} />,
        sortable: true,
        sortField: "user_name",
        grow: 0.5,
      },
      {
        name: (
          <RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "auditDashboard.table.action", defaultMessage: "Action" })} />
        ),
        selector: (row) => _get(row, "search_id", ""),
        cell: (row) => (
          <button
            type="button"
            className="btn btn-link p-0 text-capitalize m-0 border-0 text-decoration-underline"
            onClick={() => this._handleDownloadAction(_get(row, "search_id", ""))}
          >
            <FormattedMessage id="btn.download" defaultMessage="Download" />
          </button>
        ),
        sortable: false,
        grow: 0.5,
      },
    ];
  }

  componentDidMount() {
    if (this.props.isActive) {
      this._initialFetch();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isActive && !prevProps.isActive) {
      this._initialFetch();
    }

    if (!_isEqual(prevState.defaultPayload, this.state.defaultPayload)) {
      const prev = prevState.defaultPayload;
      const curr = this.state.defaultPayload;

      const dashboardFiltersChanged =
        !_isEqual(prev.user_ids, curr.user_ids) ||
        !_isEqual(prev.start_date, curr.start_date) ||
        !_isEqual(prev.end_date, curr.end_date) ||
        !_isEqual(prev.status_ids, curr.status_ids);

      if (dashboardFiltersChanged) {
        this._fetchWebScrapingDashboard();
      }

      this._fetchWebScrapingData();
    }
  }

  _initialFetch = () => {
    this._fetchWebScrapingFilters();
    this._fetchWebScrapingDashboard();
    this._fetchWebScrapingData();
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = _get(prevState, "activeRequestCount", 0) + 1;
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") {
        updatePageLevelLoadingState(true);
      }
      return { activeRequestCount: nextCount };
    });
  };

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") {
        updatePageLevelLoadingState(false);
      }
      return { activeRequestCount: nextCount };
    });
  };

  _fetchWebScrapingFilters = async () => {
    try {
      this._incrementLoader();
      const response = await fetchWebScrapingFilters();
      if (_get(response, "flag", false) === true) {
        this.setState({ filterData: _get(response, "data", {}) });
      } else {
        showAlertMessage(
          _get(response, "message", "Something went wrong while fetching web scraping filters.")
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", "Something went wrong while fetching web scraping filters.")
      );
    } finally {
      this._decrementLoader();
    }
  };

  _fetchWebScrapingDashboard = async () => {
    const { defaultPayload } = this.state;
    const payload = {
      user_ids: defaultPayload.user_ids,
      start_date: defaultPayload.start_date || null,
      end_date: defaultPayload.end_date || null,
      status_ids: defaultPayload.status_ids,
    };

    try {
      this._incrementLoader();
      const response = await getWebScrapingDashboard(payload);
      if (_get(response, "flag", false) === true) {
        this.setState({ tilesData: _get(response, "data", {}) });
      } else {
        showAlertMessage(
          _get(response, "message", "Something went wrong while fetching dashboard data.")
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", "Something went wrong while fetching dashboard data.")
      );
    } finally {
      this._decrementLoader();
    }
  };

  _fetchWebScrapingData = async () => {
    const { defaultPayload } = this.state;

    try {
      this._incrementLoader();
      const response = await getWebScrapingData({ ...defaultPayload });
      if (_get(response, "flag", false) === true) {
        // Reset row selection when data refreshes
        this.setState({
          tableData: _get(response, "data", {}),
          selectedRows: [],
          selectAllRows: false,
        });
      } else {
        showAlertMessage(
          _get(response, "message", "Something went wrong while fetching web scraping data.")
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", "Something went wrong while fetching web scraping data.")
      );
    } finally {
      this._decrementLoader();
    }
  };

  // ─── Export ───────────────────────────────────────────────────────────────

  _handleExport = async () => {
    const { intl } = this.props;
    const { defaultPayload, selectedRows, selectAllRows } = this.state;

    // Determine whether all data or specific rows should be exported
    // return_all_data = true when select-all is checked OR when no row is manually selected
    const hasManualSelection = !selectAllRows && selectedRows.length > 0;
    const returnAllData = !hasManualSelection;

    const payload = {
      user_ids: (defaultPayload.user_ids || []),
      status_ids: (defaultPayload.status_ids || []),
      start_date: (defaultPayload.start_date || ""),
      end_date: (defaultPayload.end_date || ""),
      search_ids: hasManualSelection ? selectedRows : [],
      return_all_data: returnAllData,
    };

    try {
      this._incrementLoader();
      const response = await exportWebScrapingData(payload);

      if (_get(response, "flag", false) === true) {
        const isExport = _get(response, "data.is_export", true);

        if (isExport) {
          const contentType = _get(response, "data.contentType", "");
          const contents = _get(response, "data.Contents", "");
          const filename = _get(response, "data.filename", "");

          if (contentType && contents && filename) {
            downloadExcelFile(contentType, contents, filename);
            showAlertMessage(
              intl.formatMessage({
                id: "message.file_generated_successfully",
                defaultMessage: "File generated successfully.",
              }),
              "success"
            );
          } else {
            showAlertMessage(
              intl.formatMessage({
                id: "message.file_generation_failed",
                defaultMessage: "Failed to generate file.",
              })
            );
          }
        } else {
          showAlertMessage(
            _get(response, "message", "Export initiated. Export data will be sent via email."),
            "success"
          );
        }
      } else {
        showAlertMessage(
          _get(response, "message", "Something went wrong while exporting searches.")
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", "Something went wrong while exporting searches.")
      );
    } finally {
      this._decrementLoader();
    }
  };

  _handleDownloadAction = async (searchId) => {
    const { intl } = this.props;

    if (!searchId) return;

    const payload = {
      source: "history",
      search_id: searchId
    };

    try {
      this._incrementLoader();
      const response = await exportSearchData(payload);

      if (_get(response, "flag", false) === true) {
        const isExport = _get(response, "data.is_export", true);

        if (isExport) {
          const downloadFileDetails = _get(response, "data", {});
          const contentType = _get(downloadFileDetails, "contentType", "");
          const contents = _get(downloadFileDetails, "Contents", "");
          const filename = _get(downloadFileDetails, "filename", "export.xlsx");

          if (contentType !== "" && contents !== "" && filename !== "") {
            downloadExcelFile(contentType, contents, filename);
            showAlertMessage(
              intl.formatMessage({ id: "message.file_generated_successfully", defaultMessage: "File generated successfully." }),
              "success"
            );
          } else {
            showAlertMessage(intl.formatMessage({ id: "message.file_generation_failed", defaultMessage: "Failed to generate file." }));
          }
        } else {
          showAlertMessage(_get(response, "message", "Export initiated. Export data will be sent via email"), "success");
        }
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while exporting."));
      }
    } catch (err) {
      showAlertMessage(err.message || "Something went wrong while exporting.");
    } finally {
      this._decrementLoader();
    }
  };

  // ─── Filter handlers ──────────────────────────────────────────────────────

  _handleUpdateDateRange = (startDate, endDate) => {
    this.setState((prevState) => ({
      resetDateRangePicker: false,
      defaultPayload: {
        ...prevState.defaultPayload,
        page_no: 1,
        start_date: startDate || "",
        end_date: endDate || "",
      },
    }));
  };

  _handleUserChange = (value) => {
    this.setState((prevState) => ({
      selectedUsers: value,
      defaultPayload: {
        ...prevState.defaultPayload,
        page_no: 1,
        user_ids: (value && value.length > 0) ? _map(value, "id") : null,
      },
    }));
  };

  _handleStatusChange = (value) => {
    this.setState((prevState) => ({
      selectedStatus: value,
      defaultPayload: {
        ...prevState.defaultPayload,
        page_no: 1,
        status_ids: (value && value.length > 0) ? _map(value, "status") : null,
      },
    }));
  };

  _handleResetFilters = () => {
    this.setState({
      selectedUsers: null,
      selectedStatus: null,
      resetDateRangePicker: true,
      selectedRows: [],
      selectAllRows: false,
      defaultPayload: { ...this.defaultPayload },
    });
  };

  _handlePaginationChange = (pageNo) => {
    this.setState((prevState) => ({
      defaultPayload: { ...prevState.defaultPayload, page_no: pageNo },
    }));
  };

  _handleSort = (column, sortDirection) => {
    this.setState((prevState) => ({
      defaultPayload: {
        ...prevState.defaultPayload,
        page_no: 1,
        orderby: column.sortField || "search_id",
        order: sortDirection,
      },
    }));
  };

  _handleRowSelectionChange = ({ allSelected, selectedRows: rows }) => {
    this.setState({
      selectAllRows: allSelected,
      selectedRows: _map(rows, (r) => _get(r, "search_id", null)).filter(Boolean),
    });
  };

  // ─── Render methods ───────────────────────────────────────────────────────

  _renderKPIs = () => {
    const { tilesData } = this.state;

    const totalScrapes = _get(tilesData, "top_row.total_scrapes", 0);
    const totalLeads = _get(tilesData, "top_row.total_leads", 0);
    const successPct = _get(tilesData, "top_row.success_percentage", 0);

    const cards = [
      {
        label: "Total Leads",
        messageId: "auditDashboard.kpi.total_leads",
        value: totalLeads,
        borderClass: "border-warning",
        textClass: "text-warning",
      },
      {
        label: "Success %",
        messageId: "auditDashboard.kpi.success_percentage",
        value: `${successPct}%`,
        borderClass: "border-success",
        textClass: "text-success",
      },
      {
        label: "Total Scrapes",
        messageId: "auditDashboard.kpi.total_scrapes",
        value: totalScrapes,
        borderClass: "border-blue-55",
        textClass: "text-blue-55",
      },
    ];

    return (
      <div className="row gy-4 mt-2">
        {_map(cards, (card, idx) => (
          <div className="col-lg-4" key={idx}>
            <div className={`card-static ${card.borderClass}`}>
              <h6 className={card.textClass}>{card.value}</h6>
              <p className="text-capitalize">
                <FormattedMessage id={card.messageId} defaultMessage={card.label} />
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  _renderFilters = () => {
    const { intl } = this.props;
    const { filterData, selectedUsers, selectedStatus, resetDateRangePicker } = this.state;

    const userOptions = _get(filterData, "users", []);
    const statusOptions = _get(filterData, "status", []);

    return (
      <div className="row mt-4 gy-3">
        <div className="col-lg-3">
          <label className="form-label text-capitalize">
            <FormattedMessage id="date_range_picker.title" defaultMessage="Date Range" />
          </label>
          <DateRangePicker
            resetDateRangePicker={resetDateRangePicker || false}
            onChange={(startDate, endDate) =>
              this._handleUpdateDateRange(startDate, endDate)
            }
          />
        </div>

        <div className="col-lg-3">
          <Select
            options={userOptions}
            getOptionLabel={(option) => option.name || ""}
            getOptionValue={(option) => option.id || null}
            placeholder={intl.formatMessage(
              { id: "placeholder.select_field", defaultMessage: "Select {field}" },
              {
                field: intl.formatMessage({
                  id: "auditDashboard.label.user",
                  defaultMessage: "User",
                }),
              }
            )}
            label={intl.formatMessage({
              id: "auditDashboard.label.user",
              defaultMessage: "User",
            })}
            value={selectedUsers || null}
            onChange={this._handleUserChange}
            isMulti={true}
            isClearable
          />
        </div>

        <div className="col-lg-3">
          <Select
            options={statusOptions}
            getOptionLabel={(option) => option.status_text || ""}
            getOptionValue={(option) => option.status}
            placeholder={intl.formatMessage(
              { id: "placeholder.select_field", defaultMessage: "Select {field}" },
              {
                field: intl.formatMessage({
                  id: "auditDashboard.label.status",
                  defaultMessage: "Status",
                }),
              }
            )}
            label={intl.formatMessage({
              id: "auditDashboard.label.status",
              defaultMessage: "Status",
            })}
            value={selectedStatus || null}
            onChange={this._handleStatusChange}
            isMulti={true}
            isClearable
          />
        </div>

        <div className="col-lg-3 d-flex justify-content-end align-items-end gap-2">
          <div className="mt-7">
            <button
              type="button"
              className="btn btn-dark waves-effect text-capitalize"
              onClick={this._handleResetFilters}
            >
              <FormattedMessage id="btn.reset" defaultMessage="Reset" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  _renderCharts = () => {
    const { tilesData } = this.state;

    // ── Scrape Success Trend (Line Chart) ──────────────────────────────
    const timelineCategories = _get(tilesData, "success_timeline.categories", []);
    const leadCounts = _get(tilesData, "success_timeline.leadCounts", []);
    const totalRecords = _get(tilesData, "success_timeline.totalRecords", []);

    const lineChartOptions = {
      chart: { type: "line", backgroundColor: "transparent" },
      title: { text: null },
      xAxis: {
        categories: timelineCategories,
        tickInterval: 1,
        labels: { rotation: -45, step: 1, style: { fontSize: "11px" } },
      },
      yAxis: { title: { text: "Records" }, min: 0 },
      series: [
        {
          name: "Total Records",
          data: totalRecords,
          color: "#4361ee",
          marker: { enabled: true, radius: 4 },
        },
        {
          name: "Lead Counts",
          data: leadCounts,
          color: "#2dc653",
          marker: { enabled: true, radius: 4 },
        },
      ],
      legend: { enabled: true },
      credits: { enabled: false },
      tooltip: { shared: true },
    };

    // ── Lead Quality Distribution (Pie Chart) ─────────────────────────
    const qualityCategories = _get(tilesData, "lead_quality.categories", []);
    const qualityValues = _get(tilesData, "lead_quality.values", []);

    const pieData = qualityCategories.map((cat, i) => ({
      name: cat,
      y: qualityValues[i] || 0,
    }));

    const pieColors = ["#2dc653", "#e63946"];

    const pieChartOptions = {
      chart: { type: "pie", backgroundColor: "transparent" },
      title: { text: null },
      plotOptions: {
        pie: {
          size: "85%",
          showInLegend: true,
          dataLabels: {
            enabled: true,
            distance: -40,
            format: "{point.percentage:.1f}%",
            filter: {
              property: "percentage",
              operator: ">",
              value: 0
            },
            style: {
              color: "#ffffff",
              textOutline: "none",
              fontSize: "12px",
              fontWeight: "600"
            }
          },
        },
      },
      legend: {
        enabled: true,
        labelFormatter: function () {
          return `<b>${this.name}</b>: ${this.y}`;
        }
      },
      series: [
        {
          name: "Leads",
          data: pieData.map((d, i) => ({
            ...d,
            color: pieColors[i % pieColors.length],
          })),
        },
      ],
      credits: { enabled: false },
      tooltip: {
        pointFormat: "<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)",
      },
    };

    return (
      <div className="row mt-4 gy-4">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body">
              <h6 className="card-title text-capitalize fw-semibold mb-3">
                <FormattedMessage
                  id="auditDashboard.chart.scrape_success_trend"
                  defaultMessage="Scrape Success Trend"
                />
              </h6>
              <HighchartsReact highcharts={Highcharts} options={lineChartOptions} />
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">
              <h6 className="card-title text-capitalize fw-semibold mb-3">
                <FormattedMessage
                  id="auditDashboard.chart.lead_quality"
                  defaultMessage="Lead Quality Distribution"
                />
              </h6>
              <HighchartsReact highcharts={Highcharts} options={pieChartOptions} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  _renderTableData = () => {
    const { tableData, defaultPayload } = this.state;

    const rows = _get(tableData, "web_scraping_data", []);
    const totalRecords = _get(tableData, "page_info[0].total_records", 0);

    return (
      <div className="row mt-4">
        <div className="col-lg-12 mb-3 d-flex justify-content-end align-items-end gap-2">
          <div className="mt-7">
            <button
              type="button"
              className="btn btn-primary waves-effect flex-fill"
              onClick={() => this._handleExport()}
            >
              <FormattedMessage id="auditDashboard.btn.export_searches" defaultMessage="Export Searches" />
            </button>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="custom-scroll">
            <ReactDataTable
              className="custom-scroll-460"
              columns={this.tableColumns || []}
              data={rows}
              fixedHeader={false}
              pagination={true}
              totalRecords={totalRecords}
              rowsPerPage={defaultPayload.page_size || 10}
              onChangePage={(e) => this._handlePaginationChange(e)}
              sortServer
              onSort={(col, order) => this._handleSort(col, order)}
              selectableRows
              onSelectedRowsChange={this._handleRowSelectionChange}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { intl } = this.props;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: "olympus.audit_dashboard",
              defaultMessage: "Audit Dashboard: Olympus",
            })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            {/* Page Title */}
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  <FormattedMessage id="auditDashboard.title" defaultMessage="Audit Dashboard" />
                </h1>
              </div>
            </div>

            {/* KPI Cards */}
            {this._renderKPIs()}

            {/* Filter Bar + Export */}
            {this._renderFilters()}

            {/* Charts */}
            {this._renderCharts()}

            {/* Results Table */}
            {this._renderTableData()}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(injectIntl(AuditDashboard)));
